export const hasBigInt = () => typeof BigInt === "function";
